export class OrdemServico {
  ativo: boolean;
  id: number;
  dataEmpenho: string;
  dataEntrada: string;
  dataSaida: string;
  laudo: string;
  numero: string;
  numeroEmpenho: string;
  observacoes: string;
  odometroHorimetroId: number;
  problemaInformado: string;
  status: number;
  tipo: number;
  bemId: number;
  localidadeId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/shared/ordem-servico.model.ts
 **/